<div class="card full-card shadow-sm m-4 card-v-center">
  <div class="card-body">


    <h3 class="ps-4 pb-4"><b translate>help-desk.success-request.line-1</b></h3>

    <p class="ps-4" translate>help-desk.success-request.line-2</p>

    <p class="ps-4 pe-4" translate>help-desk.success-request.line-3</p>

    @if (!directChannel) {
      <p class="ps-4 pe-4" [innerHTML]="'help-desk.success-request.line-4-bank' | translate"></p>
    }
    @if (directChannel) {
      <p class="ps-4 pe-4" [innerHTML]="'help-desk.success-request.line-4-pi' | translate" ></p>
    }

    <p class="ps-4 pe-4" [innerHTML]="'help-desk.success-request.line-5' | translate ">
    </p>

    <hr class="line" />
    <div class="w-100 row gx-0 justify-content-end">
      <button class="not btn btn-primary btn-rounded align-self-end text-nowrap col-12 col-sm-5 col-md-3 px-1 mx-md-2 my-1"
        (click)="goToHome()">
        <span class="d-inline-block" translate>
          actions.homepage
        </span>
      </button>
      <button class="btn btn-primary btn-rounded text-nowrap col-12 col-sm-5 col-md-3 flex-end p-7px px-1 my-1"
        (click)="goToHelpDeskList()">
        <span class="d-inline-block" translate>
          help-desk.rda
        </span>
      </button>
    </div>
  </div>
</div>
